export enum ConfirmationDialogActions {
  ConfirmAction = 'CONFIRM_ACTION',
  DeleteAddress = 'DELETE_ADDRESS',
  DeleteCompartment = 'DELETE_COMPARTMENT',
  DeleteCompartmentRules = 'DELETE_COMPARTMENT_RULES',
  DeleteConnection = 'DELETE_CONNECTION',
  DeleteDock = 'DELETE_DOCK',
  DeleteDpnList = 'DELETE_DPN_LIST',
  DeleteDpnversion = 'DELETE_DPN_VERSION',
  DeleteHub = 'DELETE_HUB',
  DeleteHubDriver = 'DELETE_HUB_DRIVER',
  DeleteLoanerPhone = 'DELETE_LOANER_PHONE',
  DeleteOrganization = 'DELETE_ORGANIZATION',
  DeletePartner = 'DELETE_PARTNER',
  DeletePeriod = 'DELETE_PERIOD',
  DeletePlant = 'DELETE_PLANT',
  DeleteGate = 'DELETE_GATE',
  DeleteProfile = 'DELETE_PROFILE',
  DeleteProfileFilter = 'DELETE_PROFILE_FILTER',
  DeleteSecurityQuestion = 'DELETE_SECURITY_QUESTION',
  DeleteSapEtaConfiguration = 'DELETE_SAP_ETA_CONFIGURATION',
  DeleteUser = 'DELETE_USER',
  DeleteTruckDriver = 'DELETE_TRUCK_DRIVER',
  DeleteWorkingHoursItem = 'DELETE_WORKING_HOURS_ITEM',
  DeleteYardSpot = 'DELETE_YARD_SPOT',
  NavigateAfterAllocation = 'NAVIGATE_AFTER_ALLOCATION',
  MaximumServiceTimeWarning = 'MAXIMUM_SERVICE_TIME_WARNING',
  MinimumServiceTimeWarning = 'MINIMUM_SERVICE_TIME_WARNING',
  PublishDpn = 'PUBLISH_DPN',
  PublishEula = 'PUBLISH_EULA',
  ResetPassword = 'RESET_PASSWORD',
  ReturnLoanerPhone = 'RETURN_LOANER_PHONE',
  SendNewsLetter = 'SEND_NEWS_LETTER',
  UpdateMainInfo = 'UPDATE_MAIN_INFO',
  UpdateRule = 'UPDATE_RULE',
  UpdateTruck = 'UPDATE_TRUCK',
  UserExistWarning = 'USER_EXIST_WARNING',
}
